export default __webpack_public_path__ + "static/media/Logo.071e426d.svg";